export const GOALS_ACTIONS = {
  LOAD_ROOT_OBJECTIVES: "LOAD_ROOT_OBJECTIVES",
  APPEND_ROOT_OBJECTIVES: "APPEND_ROOT_OBJECTIVES",
  LOAD_BRANCH_OBJECTIVES: "LOAD_BRANCH_OBJECTIVES",
  UPDATE_OBJECTIVE_ATTRIBUTES: "UPDATE_OBJECTIVE_ATTRIBUTES",
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
};
